webpackJsonp([118501925879540],{

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RSVPForm = function RSVPForm() {
	  return _react2.default.createElement(
	    "div",
	    { className: "rsvp-block" },
	    _react2.default.createElement(
	      "form",
	      {
	        className: "rsvp-form",
	        name: "rsvp"
	      },
	      _react2.default.createElement(
	        "fieldset",
	        null,
	        _react2.default.createElement(
	          "label",
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            "Name*"
	          ),
	          _react2.default.createElement("input", { type: "text", className: "name", name: "name", required: true })
	        ),
	        _react2.default.createElement(
	          "label",
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            "Email*"
	          ),
	          _react2.default.createElement("input", { type: "email", className: "email", name: "email", required: true })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "rsvp-attending" },
	          _react2.default.createElement(
	            "legend",
	            null,
	            "Will you be joining us?"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "radio" },
	            _react2.default.createElement("input", {
	              type: "radio",
	              value: "Attending",
	              name: "rsvp-attending",
	              id: "rsvp-attending-yes",
	              className: "a11y"
	            }),
	            _react2.default.createElement(
	              "label",
	              { htmlFor: "rsvp-attending-yes" },
	              "Yes",
	              _react2.default.createElement(
	                "span",
	                { className: "a11y" },
	                "I will be attending"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "radio" },
	            _react2.default.createElement("input", {
	              type: "radio",
	              value: "Not Attending",
	              name: "rsvp-attending",
	              id: "rsvp-attending-no",
	              className: "a11y"
	            }),
	            _react2.default.createElement(
	              "label",
	              { htmlFor: "rsvp-attending-no" },
	              "Regretfully, no",
	              _react2.default.createElement(
	                "span",
	                { className: "a11y" },
	                "I will not be attending"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "rsvp-party-size" },
	          _react2.default.createElement(
	            "legend",
	            null,
	            "How many are attending?*",
	            _react2.default.createElement(
	              "span",
	              { className: "description" },
	              "Including yourself. Please enter the number in your party."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-number" },
	            _react2.default.createElement("input", {
	              type: "number",
	              placeholder: "1",
	              name: "party-size",
	              id: "rsvp-form-party-size",
	              min: "0",
	              max: "15",
	              defaultValue: "0"
	            }),
	            _react2.default.createElement(
	              "label",
	              { htmlFor: "rsvp-form-party-size", className: "a11y" },
	              "The size of your party"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "fieldset",
	        null,
	        _react2.default.createElement(
	          "legend",
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            "What would you like for dinner?*"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "description" },
	            "Please select the meals for each member of your party. 1 per person"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "input-number" },
	          _react2.default.createElement("input", {
	            type: "number",
	            placeholder: "0",
	            name: "food-chicken",
	            id: "rsvp-form-food-chicken",
	            min: "0",
	            defaultValue: "0"
	          }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "rsvp-form-food-chicken", name: "food" },
	            "Chicken Picatta"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "input-number" },
	          _react2.default.createElement("input", {
	            type: "number",
	            placeholder: "0",
	            name: "food-fish",
	            id: "rsvp-form-food-fish",
	            min: "0",
	            defaultValue: "0"
	          }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "rsvp-form-food-fish" },
	            "New England Baked Haddock"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "input-number" },
	          _react2.default.createElement("input", {
	            type: "number",
	            placeholder: "0",
	            name: "food-vegetarian",
	            id: "rsvp-form-food-veg",
	            min: "0",
	            defaultValue: "0"
	          }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "rsvp-form-food-veg", className: "vegetarian" },
	            "Butternut Squash Ravioli"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "rsvp-attending" },
	        _react2.default.createElement(
	          "legend",
	          null,
	          "Will you also join us for Sunday brunch?"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "radio" },
	          _react2.default.createElement("input", {
	            type: "radio",
	            value: "Attending Brunch",
	            name: "rsvp-attending-brunch",
	            id: "rsvp-attending-brunch-yes",
	            className: "a11y"
	          }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "rsvp-attending-brunch-yes" },
	            "Yes"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "radio" },
	          _react2.default.createElement("input", {
	            type: "radio",
	            value: "Not Attending Brunch",
	            name: "rsvp-attending-brunch",
	            id: "rsvp-attending-brunch-no",
	            className: "a11y"
	          }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "rsvp-attending-brunch-no" },
	            "Regretfully, no"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "fieldset",
	        null,
	        _react2.default.createElement(
	          "button",
	          { type: "submit" },
	          "Send your RSVP"
	        )
	      )
	    )
	  );
	};
	
	exports.default = RSVPForm;
	module.exports = exports["default"];

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _flowers = __webpack_require__(136);
	
	var _flowers2 = _interopRequireDefault(_flowers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RSVPHero = function (_Component) {
	  _inherits(RSVPHero, _Component);
	
	  function RSVPHero() {
	    _classCallCheck(this, RSVPHero);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RSVPHero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'hero rsvp-hero' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'rsvp-hero--heading' },
	        this.props.heading
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'rsvp-hero--subheading' },
	        this.props.subheading
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'overlay' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flowers flowers-left' },
	          _react2.default.createElement('img', { src: _flowers2.default, alt: 'An illustration of flowers' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flowers flowers-right' },
	          _react2.default.createElement('img', { src: _flowers2.default, alt: 'An illustration of flowers' })
	        )
	      )
	    );
	  };
	
	  return RSVPHero;
	}(_react.Component);
	
	exports.default = RSVPHero;
	
	
	RSVPHero.PropTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  subheading: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/flowers.1b59a055.svg";

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RSVPHero = __webpack_require__(83);
	
	var _RSVPHero2 = _interopRequireDefault(_RSVPHero);
	
	var _RSVPForm = __webpack_require__(82);
	
	var _RSVPForm2 = _interopRequireDefault(_RSVPForm);
	
	var _Header = __webpack_require__(22);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(21);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heading = 'We’re getting married on November 24th.';
	var subheading = '\n  In Methuen, there\u2019s an amazing music hall with a two hundred-year-old organ.\n  It\u2019s beautiful and we would love for you to see it when we get married.\n';
	
	var RSVPPage = function RSVPPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'rsvp-page' },
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(_RSVPHero2.default, { heading: heading, subheading: subheading }),
	    _react2.default.createElement(_RSVPForm2.default, null),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	exports.default = RSVPPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rsvp-js-a29b2a672e7a4ce41fb1.js